module.exports = __webpack_public_path__ + "images/404-3b6bed758da2bdeee4423f617dc5538f.svg";